import { DialogModal } from "@common/components/alert/dialog/DialogModal"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useState } from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"

export const MaterialImage = (props) => {
    const {
        images,
        setImages,
        renderIconButton,
        canDeleteImage,
        handleShowMaterialModal = () => {},
        title,
        description,
        multiple = false,
    } = props

    const [confirmModalVisible, setConfirmModalVisible] = useState(false)
    const [deleteIndex, setDeleteIndex] = useState(null)

    const handleDeleteImage = (index) => {
        if (multiple && images.length > 1) {
            // Multiple mode: delete specific image
            setDeleteIndex(index)
            setConfirmModalVisible(true)
        } else {
            // Single mode or last image: delete all
            setConfirmModalVisible(true)
        }
    }

    const confirmDelete = () => {
        if (multiple && deleteIndex !== null && images.length > 1) {
            // Delete specific image
            const newImages = images.filter((_, index) => index !== deleteIndex)
            setImages(newImages)
            setDeleteIndex(null)
        } else {
            // Delete all
            setImages([])
        }
        setConfirmModalVisible(false)
    }

    return (
        <TouchableOpacity
            style={{
                backgroundColor: theme.colors.primaryLighter,
                borderRadius: theme.roundness,
                marginTop: 20,
                padding: 20,
            }}
            onPress={handleShowMaterialModal}
            disabled={props.canOpenImage === false}
        >
            <View
                style={{
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "stretch",
                    alignSelf: "center",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <TextM
                        wrap
                        fontWeight="ExtraBold"
                        color={theme.colors.primary}
                        fontSize={18}
                        style={{}}
                    >
                        {title ? title : "Image"}
                    </TextM>
                    <TextM
                        wrap
                        fontWeight="Regular"
                        color={theme.colors.grey}
                        fontSize={14}
                        style={{}}
                    >
                        {description ? description : ""}
                    </TextM>
                </View>
                {multiple && images.length > 1 ? (
                    // Multiple images: show grid
                    <ScrollView
                        horizontal
                        showsHorizontalScrollIndicator={false}
                        style={{ marginTop: 15 }}
                        contentContainerStyle={{ paddingHorizontal: 5 }}
                    >
                        {images.map((image, index) => (
                            <View
                                key={index}
                                style={{
                                    marginHorizontal: 5,
                                    position: "relative",
                                }}
                            >
                                <IconImageM
                                    source={{ uri: image?.uri ?? image }}
                                    resizeMode={"cover"}
                                    width={100}
                                    height={100}
                                    style={{ borderRadius: theme.roundness }}
                                />
                                {canDeleteImage &&
                                    renderIconButton(() =>
                                        handleDeleteImage(index)
                                    )}
                            </View>
                        ))}
                    </ScrollView>
                ) : (
                    // Single image: show large preview
                    <>
                        <IconImageM
                            source={{ uri: images[0]?.uri ?? images[0] }}
                            resizeMode={"contain"}
                            width={160}
                            height={160}
                            style={{ alignSelf: "center", marginTop: 15 }}
                        />
                        {canDeleteImage &&
                            renderIconButton(() => handleDeleteImage(0))}
                    </>
                )}
            </View>
            <DialogModal
                visible={confirmModalVisible}
                onDismiss={() => {
                    setConfirmModalVisible(false)
                    setDeleteIndex(null)
                }}
                title={
                    multiple && deleteIndex !== null && images.length > 1
                        ? "Retirer cette image ?"
                        : "Retirer l'image ?"
                }
                onConfirm={confirmDelete}
            />
        </TouchableOpacity>
    )
}
